import { render, staticRenderFns } from "./AddOrderDetail.vue?vue&type=template&id=328b2d2a&"
import script from "./AddOrderDetail.vue?vue&type=script&lang=js&"
export * from "./AddOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports